import { render, staticRenderFns } from "./LmProcessPrivileges.vue?vue&type=template&id=38a8278d"
import script from "./LmProcessPrivileges.vue?vue&type=script&lang=js"
export * from "./LmProcessPrivileges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports